import { AccessTimeOutlined as AccessTimeOutlinedIcon, Info as InfoIcon } from '@mui/icons-material'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import { Alert, Button, Typography } from '@mui/material'
import type { JSX } from 'react'

type Color = 'success' | 'info' | 'warning' | 'error'

export enum EIconType {
  success = 'success',
  warning = 'warning',
  error = 'error',
  info = 'info',
  waiting = 'waiting',
}

interface Props {
  iconMessage?: string
  iconType?: EIconType | null
  onClick?: () => void
}
const IconSection = ({ iconMessage, iconType, onClick }: Props) => {
  let icon: JSX.Element | null
  let color: Color = 'info'
  switch (iconType) {
    case EIconType.success:
      color = 'success'
      icon = <CheckCircleOutlineIcon />
      break
    case EIconType.error:
      color = 'error'
      icon = <HighlightOffIcon />
      break
    case EIconType.warning:
      color = 'warning'
      icon = <ErrorOutlineIcon />
      break
    case EIconType.info:
      color = 'info'
      icon = <InfoIcon />
      break
    case EIconType.waiting:
      color = 'info'
      icon = <AccessTimeOutlinedIcon />
      break
    default:
      icon = null
  }
  if (onClick)
    return (
      <Button
        onClick={onClick}
        variant="contained"
        color={color}
        sx={{
          borderRadius: 0,
          py: '13px',
          textTransform: 'none',
        }}
        startIcon={<HelpOutlineIcon />}
      >
        <Typography variant="body1" fontWeight="bold">
          {iconMessage}
        </Typography>
      </Button>
    )
  return (
    <Alert
      variant="filled"
      severity={color}
      icon={icon}
      sx={{ display: 'flex', justifyContent: 'center', borderRadius: 0 }}
    >
      <Typography variant="body1" fontWeight="bold">
        {iconMessage}
      </Typography>
    </Alert>
  )
}

export default IconSection
